import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/news/list/[id]/page.tsx");
